import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const contactGroupsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/contact-groups",
  component: lazyRouteComponent(() => import("./contact-groups.page.js"), "ContactGroupsPage"),
});
